import { useEffect, useMemo, useState } from "react";
import { DialogContent, DialogContentText, Grid } from "@mui/material";

import Popup from "../../../components/common/model/Popup";
import useStyles from "../../../components/common/model/styles";
import FormField from "../../../components/common/FormField";

import closeIcon from "../../../assets/closeModel.png";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import AlertPopup from "../../../components/common/alertPopup/AlertPopup";

import Validation from "../../../utils/Validation";
import {
  addSiteUnitAction,
  clearUnitTypeDetails,
  getAllUnitTypesAction,
  getSingleSiteUnitAction,
  getSingleUnitTypeAction,
  initialSiteUnitLocalState,
  updateSiteUnitAction,
} from "../../../store/reducers/storageSettingSlice";
import ResetFormAlert from "../Communication/ResetFormAlert";
import {
  FORM_ELEMENT_FIELDS,
  isValidPattern,
} from "../storage/unitType/unitAllFields";
import { SiteUnit } from "../storage/unitType/unit.type";
import { useDispatch, useSelector } from "react-redux";
import Notification from "../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import { formatTime } from "../../../hooks/helper";

interface ManageUnitProps {
  open: boolean;
  onHide: () => void;
  title: string;
  selectUser?: any;
  isSmallScreen?: boolean;
  selectedSiteId?: string;
  selectedUnitId?: string | null;
}

export const getInitialSiteUnitState = (): SiteUnit => ({
  id: null,
  unitTypeId: null,
  storageType: null,
  sizeFt3: null,
  unitWidth: null,
  unitLength: null,
  unitHeight: null,
  rentType: null,
  unitNumbering: "Sequential Numbering",
  prefix: null,
  rangeStart: null,
  rangeEnd: null,
  pricePerUnit: null,
  quantity: null,
  siteAccessHours: null,
  accessStartTime: null,
  accessEndTime: null,
  securityDepositType: null,
  securityDepositValue: null,
});

const ManageUnit = ({
  open,
  onHide,
  title,
  selectedSiteId,
  selectedUnitId,
}: ManageUnitProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { unitTypeSummarys, unitTypeDetails, singleSiteUnitResponse } =
    useSelector((state: any) => state.storageSetting);
  const [unitDetails, setUnitDetails] = useState<SiteUnit>(
    initialSiteUnitLocalState,
  );
  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    unitTypeId: unitDetails.unitTypeId,
    storageType: unitDetails.storageType,
    // sizeFt3: unitDetails.sizeFt3,
    quantity: unitDetails.quantity,
    unitNumbering: unitDetails.unitNumbering,
    // prefix: unitDetails.prefix,
    pricePerUnit: unitDetails.pricePerUnit,
    // unitWidth: unitDetails.unitWidth,
    // unitLength: unitDetails.unitLength,
    // unitHeight: unitDetails.unitHeight,
    // security_deposit: unitTypeDetails.security_deposit,
  });

  useEffect(() => {
    if (selectedSiteId && selectedUnitId) {
      dispatch(
        getSingleSiteUnitAction({
          siteId: selectedSiteId,
          siteUnitId: selectedUnitId,
        }),
      );
    }
  }, [selectedSiteId, selectedUnitId]);

  useEffect(() => {
    if (singleSiteUnitResponse?.site_id) {
      console.log("singleSiteUnitResponse",singleSiteUnitResponse);
      setUnitDetails({
        ...singleSiteUnitResponse,
        unitTypeId: singleSiteUnitResponse.unit_type_id ?? null,
        storageType: singleSiteUnitResponse.storage_type ?? null,
        sizeFt3: singleSiteUnitResponse.size_ft3 ?? null,
        pricePerUnit: Number(singleSiteUnitResponse.price_per_unit) ?? null,
        unitWidth: singleSiteUnitResponse.unit_width ?? null,
        unitLength: singleSiteUnitResponse.unit_length ?? null,
        unitHeight: singleSiteUnitResponse.unit_height ?? null,
        prefix: singleSiteUnitResponse.prefix ?? null,
        rentType: singleSiteUnitResponse.rent_type ?? null,
        unitNumbering: singleSiteUnitResponse.unit_numbering ?? null,
        quantity: singleSiteUnitResponse.batch_quantity ?? null,
        rangeStart: singleSiteUnitResponse.range_start ?? null,
        rangeEnd: singleSiteUnitResponse.range_end ?? null,
        siteAccessHours: singleSiteUnitResponse.site_access_hours ?? null,
        accessStartTime:
          formatTime(singleSiteUnitResponse.access_start_time) ?? null,
        accessEndTime:
          formatTime(singleSiteUnitResponse.access_end_time) ?? null,
        securityDepositType:
          singleSiteUnitResponse.security_deposit_type ?? null,
        securityDepositValue:
          singleSiteUnitResponse.security_deposit_value ?? null,
      });
    }
  }, [singleSiteUnitResponse]);

  useEffect(() => {
    if (open) {
      setUnitDetails(getInitialSiteUnitState());

      dispatch(clearUnitTypeDetails());
      dispatch(
        getAllUnitTypesAction({
          page: 1,
          limit: 10,
          orderBy: "created_at",
          orderIn: "DESC",
          search: "",
        }),
      );
    }
  }, [open]);

  const UPDATE_FORM_DATA = FORM_ELEMENT_FIELDS.map((field) => {
    if (field.id === "unitTypeId") {
      const unitTypeOptions = (unitTypeSummarys || []).map((type: any) => ({
        label: type.unit_type_name,
        id: type.id, // send label instead of ID
        // tooltip: type.description || type.tooltip || "",
      }));

      return {
        ...field,
        options: unitTypeOptions,
      };
    }
    return field;
  });

  const handleUnitTypeChange = (value: string) => {
    setUnitDetails((prev) => ({ ...prev, unitTypeId: value }));
    resetValidator("unitTypeId");
    dispatch(getSingleUnitTypeAction({ unitTypeId: value })); // fetch full details by id
  };

  // Fill dimensions once the fetched details land in the store
  useEffect(() => {
    if (!unitTypeDetails) return;
    console.log("unitTypeDetails",unitTypeDetails);
    const quantity = unitTypeDetails?.quantity ?? null;

    const rangeStart =
      unitTypeDetails?.range_start !== null &&
      unitTypeDetails?.range_start !== undefined &&
      unitTypeDetails?.range_start !== ""
        ? String(unitTypeDetails.range_start)
        : quantity
          ? "1"
          : "";

    const rangeEnd =
      unitTypeDetails?.range_end !== null &&
      unitTypeDetails?.range_end !== undefined &&
      unitTypeDetails?.range_end !== ""
        ? String(unitTypeDetails.range_end)
        : rangeStart !== "" && quantity
          ? String(Number(rangeStart) + Number(quantity) - 1)
          : "";

    setUnitDetails((prev) => ({
      ...prev,

      storageType: unitTypeDetails.storage_type ?? null,
      sizeFt3: unitTypeDetails.size_ft3 ?? null,
      pricePerUnit:  unitTypeDetails?.price_per_unit !== null &&
  unitTypeDetails?.price_per_unit !== undefined &&
  unitTypeDetails?.price_per_unit !== ""
    ? Number(unitTypeDetails.price_per_unit)
    : null,

      unitWidth: unitTypeDetails.unit_width ?? null,
      unitLength: unitTypeDetails.unit_length ?? null,
      unitHeight: unitTypeDetails.unit_height ?? null,

      prefix: unitTypeDetails?.prefix ?? null,
      rentType: unitTypeDetails?.rent_type ?? null,
      unitNumbering: unitTypeDetails?.unit_numbering ?? null,

      quantity,

      // Always use NEW unit type range
      rangeStart,
      rangeEnd,

      siteAccessHours: unitTypeDetails?.site_access_hours ?? null,

      accessStartTime: formatTime(unitTypeDetails?.access_start_time) ?? null,

      accessEndTime: formatTime(unitTypeDetails?.access_end_time) ?? null,

      securityDepositType: unitTypeDetails?.security_deposit_type ?? null,

      securityDepositValue: unitTypeDetails?.security_deposit_value ?? null,
    }));
  }, [unitTypeDetails]);

  const handleInputChange = (field: string, value: string) => {
    if (field === "pricePerUnit") {
      setUnitDetails((prev) => ({
        ...prev,
        pricePerUnit: value === "" ? null : Number(value),
      }));
      resetValidator(field);
      return;
    }
    if (field === "quantity") {
      const qty = value === "" ? "" : Number(value);
      const start = Number(unitDetails?.rangeStart);

      let calculatedEnd: number | "" = "";
      if (
        unitDetails?.rangeStart !== null &&
        unitDetails?.rangeStart !== "" &&
        !isNaN(start) &&
        qty !== "" &&
        !isNaN(qty as number) &&
        (qty as number) > 0
      ) {
        calculatedEnd = start + (qty as number) - 1;
      }

      setUnitDetails((prev: any) => ({
        ...prev,
        quantity: value,
        rangeEnd: calculatedEnd === "" ? "" : String(calculatedEnd),
      }));
      resetValidator(field);
      return;
    }

    setUnitDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
    resetValidator(field);
  };

  // 👇 NEW: When rangeStart changes, auto-calculate rangeEnd based on quantity.
  // rangeEnd = rangeStart + quantity - 1  (so the span always has exactly `quantity` numbers)
  const handleRangeStartChange = (value: string) => {
    const start = value === "" ? "" : Number(value);
    const qty = Number(unitDetails?.quantity);

    let calculatedEnd: number | "" = "";
    if (value !== "" && !isNaN(start as number) && qty > 0) {
      calculatedEnd = (start as number) + qty - 1;
    }

    setUnitDetails((prev) => ({
      ...prev,
      rangeStart: value,
      rangeEnd: calculatedEnd === "" ? "" : String(calculatedEnd),
    }));
  };

  const onBlurAction = () => {};

  const handleClear = () => {
    setUnitDetails(initialSiteUnitLocalState);
    dispatch(clearUnitTypeDetails());
    resetAllValidator();
    setIsClickReset(false);
    setAlertModelShow(false);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const hideHandler = () => {
    handleClear();
    onHide();
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (!isError() && error !== null && isActionCalled) {
      const finalPayload = {
        ...unitDetails,
        pricePerUnit:
          unitDetails.pricePerUnit != null
            ? Number(unitDetails.pricePerUnit)
            : null,
        quantity: Number(unitDetails?.quantity),
        rangeStart: Number(unitDetails?.rangeStart),
        rangeEnd: Number(unitDetails?.rangeEnd),
      };
      if (finalPayload?.id !== null && finalPayload?.id !== undefined) {
        dispatch(
          updateSiteUnitAction({
            ...finalPayload,
            siteId: selectedSiteId,
            siteUnitId: finalPayload?.id,
          }),
        );
      } else {
        dispatch(
          addSiteUnitAction({ ...finalPayload, siteId: selectedSiteId }),
        );
      }
      setIsActionCalled(false);
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth
        maxWidth="md"
        popupBg="#fff"
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              src={checkedIcon}
              alt="save"
              className={classes.checkicons}
              onClick={(e: any) => handleSubmit(e)}
            />

            <img
              src={deleteIcon}
              alt="delete"
              className={classes.deleteicons}
              onClick={openClearPopup}
            />

            <img
              src={closeIcon}
              alt="close"
              className={classes.closeicons}
              onClick={hideHandler}
            />
          </>
        }
      >
        <DialogContent sx={{ p: "16px 10px !important" }}>
          <DialogContentText component="div">
            <Notification />
            <div style={{ display: "flex", gap: "24px" }}>
              {/* Left column: Unit Details */}
              <div style={{ flex: 1 }}>
                <h4>Unit Details</h4>
                <Grid
                  container
                  spacing={0.5}
                  sx={{
                    border: "1px solid #f3f3f3",
                    background: "#f4f4f4",
                    p: 2,
                    borderRadius: "5px",
                    mt: 1,
                  }}
                >
                  {UPDATE_FORM_DATA.filter((f) => {
                    if (f.section !== "unitDetails") return false;
                    // Hide this field while editing an existing unit; show only when adding new
                    if (f.isEditableHide && unitDetails?.id) return false;
                    // Hide Quantity when editing existing unit
                    if (unitDetails?.id && f.id === "quantity") {
                      return false;
                    }
                    if (f.dependsOn) {
                      return (
                        unitDetails[f.dependsOn.field as keyof SiteUnit] ===
                        f.dependsOn.value
                      );
                    }
                    return true;
                  }).map((field) => (
                    // <Grid item xs={field.md} key={field.id}>
                    <FormField
                      {...field}
                      inSingleGridForm
                      isNonMarginTop
                      options={field.options}
                      // rangeEnd is derived from rangeStart + quantity, so lock it from manual edits
                      disabled={
                        field.id === "rangeEnd" ||
                        // (field.id === "unitTypeId" &&
                        //   unitDetails?.id &&
                        //   String(
                        //     singleSiteUnitResponse?.status || "",
                        //   ).toLowerCase() === "occupied")
                        //   ? true
                        //   :
                           field.disabled
                      }
                      value={unitDetails?.[field.id as keyof SiteUnit] ?? ""}
                      error={!!(error && error[field?.id])}
                      // helperText={error?.[field?.id]}
                      InputProps={{
                        // ✅ Conditionally apply maxLength only if defined in field config
                        ...(field?.maxLength && { maxLength: field.maxLength }),
                        sx: {
                          height:
                            field?.id === "notes" &&
                            (unitDetails[field.id as keyof SiteUnit]
                              ? String(unitDetails[field.id as keyof SiteUnit])
                                  .length
                              : 0) > 36
                              ? "auto"
                              : "36px",
                          padding: field?.id === "notes" ? "4px" : "",
                        },
                      }}
                      onBlur={onBlurAction}
                      onChange={(e: any) => {
                        if (field.id === "unitTypeId") {
                          handleUnitTypeChange(e.target.value);
                        } else if (field.id === "rangeStart") {
                          handleRangeStartChange(e.target.value);
                        } else {
                          handleInputChange(field.id, e.target.value);
                        }
                      }}
                      onPaste={(
                        event: React.ClipboardEvent<HTMLInputElement>,
                      ) => {
                        if (!field?.patternAllowed) {
                          return;
                        }

                        const pastedText = event.clipboardData.getData("text");
                        const currentValue = event.currentTarget.value;

                        const newValue = currentValue + pastedText;

                        if (!isValidPattern(field.patternAllowed, newValue)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyDown={(event: any) => {
                        if (
                          [8, 9, 17, 18, 37, 38, 39, 40].includes(
                            event.keyCode,
                          ) ||
                          event.ctrlKey
                        ) {
                          return;
                        }

                        if (
                          field?.patternAllowed &&
                          !field.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                          return;
                        }

                        if (
                          field?.patternAllowed &&
                          !field.patternAllowed.test(
                            event.target.value + event.key,
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                    // </Grid>
                  ))}
                </Grid>
                <h4>Dimensions (per unit)</h4>
                <Grid
                  container
                  spacing={0.5}
                  sx={{
                    border: "1px solid #f3f3f3",
                    background: "#f4f4f4",
                    p: 2,
                    borderRadius: "5px",
                    mt: 1,
                  }}
                >
                  {FORM_ELEMENT_FIELDS.filter(
                    (f) => f.section === "dimensions",
                  ).map((field) => (
                    //  <Grid item xs={field.md} key={field.id}>
                    <FormField
                      {...field}
                      inSingleGridForm
                      isNonMarginTop
                      value={unitDetails?.[field.id as keyof SiteUnit] ?? ""}
                      error={!!(error && error[field?.id])}
                      // helperText={error?.[field?.id]}
                      InputProps={{
                        // ✅ Conditionally apply maxLength only if defined in field config
                        ...(field?.maxLength && { maxLength: field.maxLength }),
                        sx: {
                          height:
                            field?.id === "notes" &&
                            (unitDetails[field.id as keyof SiteUnit]
                              ? String(unitDetails[field.id as keyof SiteUnit])
                                  .length
                              : 0) > 36
                              ? "auto"
                              : "36px",
                          padding: field?.id === "notes" ? "4px" : "",
                        },
                      }}
                      onBlur={onBlurAction}
                      onChange={(e: any) =>
                        handleInputChange(field.id, e.target.value)
                      }
                      onPaste={(e: any) => {
                        if (field?.id !== "type_name") {
                          e.preventDefault();
                        }
                      }}
                      onKeyDown={(event: any) => {
                        if (
                          [8, 9, 17, 18, 37, 38, 39, 40].includes(
                            event.keyCode,
                          ) ||
                          event.ctrlKey
                        ) {
                          return;
                        }

                        if (
                          field?.patternAllowed &&
                          !field.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                          return;
                        }

                        if (
                          field?.patternAllowed &&
                          !field.patternAllowed.test(
                            event.target.value + event.key,
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                    />
                    // </Grid>
                  ))}
                </Grid>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title="Alert"
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageUnit;
